<template>
    <div class="chip-group">
        <button
            v-for="option in options"
            :key="option"
            :class="isSelected(option) ? 'chip-base chip-enabled' : 'chip-base chip-disabled'"
            @click="toggle(option)"
        >
            {{ isSelected(option) ? '✓ ' + option : option }}
        </button>
    </div>
</template>

<script lang="ts">
export default {
    name: "ChipGroup",
    emits: ["update:modelValue"],
    props: {
        options: {
            type: Array as () => string[],
            required: true,
        },
        modelValue: {
            type: Array as () => string[],
            required: true,
        },
    },
    methods: {
        isSelected(option: string): boolean {
            return this.modelValue.includes(option);
        },
        toggle(option: string) {
            const updated = this.isSelected(option)
                ? this.modelValue.filter((o) => o !== option)
                : [...this.modelValue, option];
            this.$emit("update:modelValue", updated);
        },
    },
};
</script>

<style scoped>
.chip-group {
    display: flex;
    justify-content: flex-start;
    gap: var(--spacing-xs);
    margin-left: var(--spacing-sm);
}
</style>
